/**
 * @param {import('./menuTypes.js').MenuItemProps} prev
 * @param {import('./menuTypes.js').MenuItemProps} next
 */
export function areMenuItemPropsEqual(prev, next) {
  if (
    prev.label !== next.label ||
    prev.description !== next.description ||
    prev.size !== next.size ||
    prev.state !== next.state ||
    prev.disabled !== next.disabled ||
    prev.loading !== next.loading ||
    prev.selected !== next.selected ||
    prev.selectedSurface !== next.selectedSurface ||
    prev.role !== next.role ||
    prev.subtextMenu !== next.subtextMenu ||
    prev.button !== next.button ||
    prev.showClose !== next.showClose ||
    prev.className !== next.className ||
    prev.closeAriaLabel !== next.closeAriaLabel ||
    prev.onClick !== next.onClick ||
    prev.onClose !== next.onClose ||
    prev.icon !== next.icon ||
    prev.highlightIcon !== next.highlightIcon
  ) {
    return false;
  }

  if (Boolean(prev.checkbox) !== Boolean(next.checkbox)) return false;

  return areAvatarsEqual(prev.avatar, next.avatar);
}

function areAvatarsEqual(a, b) {
  if (a === b) return true;
  if (!a || !b) return !a && !b;
  if (a === true || b === true) return a === b;
  return (
    a.src === b.src &&
    a.initials === b.initials &&
    a.className === b.className &&
    a.alt === b.alt
  );
}
